<template>
  <!-- rf12 -->
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-flex shrink style="text-align: right"><v-btn dark @click="printPage()"
            style="width: 80px; background-color: black;"><v-icon>local_printshop</v-icon></v-btn></v-flex>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout mx-6>
              <v-flex>
                <v-layout style="background-color: #3E7662;">
                  <v-flex my-4 ml-8 style="text-align: left;font-size: 28px;color: white">
                    <div style="font-weight: bold">
                      แบบประเมินส่วนแก้ไขเพิ่มเติมโครงร่างของการวิจัย
                    </div>
                    <div style="font-size: 18px;">
                      Assessment Form of Protocol Amendment
                    </div>
                  </v-flex>
                  <v-flex ml-8 pt-8 pr-8 style="text-align: right;font-weight: bold;font-size: 13px;color: white">
                    <span>RO 05_2563</span>
                  </v-flex>
                </v-layout>

                <!-- Start Form -->

                <!-- Card 1 -->
                <v-card class="mb-12">
                  <v-layout pa-12 class="justify-center">
                    <v-flex xs10>
                      <!-- row 1 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>รหัสโครงร่างการวิจัย</b>
                        </v-flex>
                        <v-flex xs4 class="text-start">
                          <TextfieldForm readonly :model="form.researchCode" hide-detail
                            @update-data="updateData('researchCode', $event)" />
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout mb-8>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>ชื่อผู้วิจัยหลัก</b>
                        </v-flex>
                        <v-flex xs4 class="text-start">
                          <TextfieldForm readonly :model="form.firstName" hide-detail
                            @update-data="updateData('firstName', $event)" />
                        </v-flex>
                        <v-flex mx-4 xs1 class="d-flex justify-end align-center">
                          <b>นามสกุล</b>
                        </v-flex>
                        <v-flex>
                          <TextfieldForm readonly :model="form.lastName" hide-detail
                            @update-data="updateData('lastName', $event)" />
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout>
                        <v-flex mr-4 xs2 class="d-flex justify-end align-center">
                          <b>ชื่อโครงการวิจัย (ไทย)</b>
                        </v-flex>
                        <v-flex>
                          <textarea-form hide-detail :model="form.researchName"
                            @update-data="updateData('researchName', $event)"></textarea-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 2 -->
                <v-card class="mb-12">
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex>
                      <span>TYPE OF AMENDMENT</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pa-12>
                    <v-flex>
                      <v-radio-group v-model="form.checkborad">
                        <!-- EXPEDITED REVIEW (Check the criteria) -->
                        <v-layout mb-8>
                          <v-flex shrink class="text-start d-flex align-center">
                            <v-radio value="1" @click="checkbox('checkTheCriteria11')"></v-radio>
                          </v-flex>
                          <v-flex class="text-start">
                            <span class="font-weight-bold">EXPEDITED REVIEW (Check the criteria)</span>
                          </v-flex>
                        </v-layout>
                        <!-- Form Checkbox -->
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria1"
                              label="การแก้ไขระบบบริหารจัดการ เช่น ชื่อที่ปรึกษา ผู้วิจัยร่วม ชื่อผู้ประสานงานโครงการวิจัย"
                              color="#3E7662" hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria2"
                              label="การแก้ไขคู่มือผู้วิจัย (Investigator brochure) ที่ไม่เพิ่มความเสี่ยงต่ออาสาสมัคร"
                              color="#3E7662" hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria3"
                              label="การเปลี่ยนแปลงเล็กน้อย เช่น การแก้ไขการสะกดคำ วันที่ ฉบับ การจัดรูปเล่มของโครงร่างการวิจัย"
                              color="#3E7662" hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria4"
                              label="การแก้ไขข้อความประชาสัมพันธ์เชิญชวนอาสาสมัครเข้าสู่โครงการวิจัย" color="#3E7662"
                              hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria5"
                              label="การแก้ไขหรือเพิ่มเติมสัญญา ข้อตกลงการส่งมอบวัสดุ เอกสารที่ใช้ในการวิจัย (material transfer agreement)"
                              color="#3E7662" hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria6"
                              label="การแก้ไขใดๆ ในโครงการวิจัยที่ไม่มีการคัดอาสาสมัครใหม่เข้ามาในการศึกษา และการทำกิจกรรมหรือหัตถการเกี่ยวกับการวิจัยกับอาสาสมัครได้สิ้นสุดแล้วคงเหลือแต่เพียงการติดตามอาสาสมัคร"
                              color="#3E7662" hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria7"
                              label="การแก้ไขหรือเพิ่มเติมวิธีดำเนินการวิจัย ที่ไม่เพิ่มความเสี่ยงแก่อาสาสมัคร หรือมีความเสี่ยงไม่มากกว่าความเสี่ยงเล็กน้อย หรือหากมากกว่าความเสี่ยงเล็กน้อยก็เป็นการกระทำเพื่อจุดประสงค์ของการรักษาตามเวชปฏิบัติทั่วไป ไม่ใช่หัตถการเพื่อการวิจัย"
                              color="#3E7662" hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria8"
                              label="การดำเนินการในโครงการวิจัยสิ้นสุดแล้ว เหลือเพียงการวิเคราะห์ข้อมูล" color="#3E7662"
                              hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria9" label="การแก้ไขหรือเพิ่มเติมวิธีวิเคราะห์ข้อมูล"
                              color="#3E7662" hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria10" label="การปรับแก้ชื่อโครงร่างการวิจัย" color="#3E7662"
                              hide-details :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout ml-6>
                          <v-flex shrink class="text-start d-flex align-center">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.checkTheCriteria11" label="อื่นๆ ระบุ" color="#3E7662" hide-details
                              @click.native="checkbox('checkTheCriteria11')"
                              :disabled="form.checkborad != 1"></v-checkbox>
                          </v-flex>
                          <v-flex ml-2 mt-2 class="text-start">
                            <v-textarea :readonly="$route.query.read == 1 ? true : false"
                              :disabled="!form.checkTheCriteria11" v-model="form.criteria11" outlined dense solo flat
                              rows="3" background-color="#FBF6F3" item-color="#3E7662" color="#3E7662"
                              style="height: 96px;"></v-textarea>
                          </v-flex>
                        </v-layout>

                        <!-- FULL BOARD REVIEW -->
                        <v-layout mt-12>
                          <v-flex shrink class="text-start d-flex align-center">
                            <v-radio value="2" @click="checkbox('hasFullBoardReview')"></v-radio>
                          </v-flex>
                          <v-flex class="text-start">
                            <span class="font-weight-bold">FULL BOARD REVIEW</span>
                          </v-flex>
                        </v-layout>
                        <v-layout ml-6>
                          <v-flex shrink class="text-start d-flex align-center">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false"
                              v-model="form.hasFullBoardReview" label="ระบุ" color="#3E7662" hide-details
                              @click.native="checkbox('hasFullBoardReview')"
                              :disabled="form.checkborad != 2"></v-checkbox>
                          </v-flex>
                          <v-flex ml-2 mt-2 class="text-start">
                            <v-textarea :readonly="$route.query.read == 1 ? true : false" v-model="form.fullBoardReview"
                              outlined dense solo flat rows="3" background-color="#FBF6F3" item-color="#3E7662"
                              color="#3E7662" style="height: 96px;" :disabled="form.checkborad != 2"></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 3 -->
                <v-card class=" mb-12">
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex>
                      <span>ความเสี่ยงและประโยชน์ต่ออาสาสมัคร</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pa-12>
                    <v-flex>
                      <!-- ความเสี่ยงที่อาจเกิดขึ้น -->
                      <v-layout mb-6>
                        <v-flex class="text-start">
                          <span class="font-weight-bold">ความเสี่ยงที่อาจเกิดขึ้น</span>
                        </v-flex>
                      </v-layout>
                      <!-- Form Radio -->
                      <v-layout mt-5 ml-6>
                        <v-flex class="text-start">
                          <v-radio-group :readonly="$route.query.read == 1 ? true : false" v-model="form.risk" row>
                            <v-radio color="#3E7662" style="padding-right: 50px" label="เพิ่มขึ้น" value="1"></v-radio>
                            <v-radio color="#3E7662" style="padding-right: 50px" label="คงเดิม" value="2"></v-radio>
                            <v-radio color="#3E7662" label="ลดลง" value="3"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <!-- ประโยชน์ที่คาดว่าจะได้รับ -->
                      <v-layout mt-12>
                        <v-flex class="text-start">
                          <span class="font-weight-bold">ประโยชน์ที่คาดว่าจะได้รับ</span>
                        </v-flex>
                      </v-layout>
                      <!-- Form Radio -->
                      <v-layout mt-5 ml-6>
                        <v-flex class="text-start">
                          <v-radio-group v-model="form.expectBenefit" row
                            :readonly="$route.query.read == 1 ? true : false">
                            <v-radio color="#3E7662" style="padding-right: 50px" label="เพิ่มขึ้น" value="1"></v-radio>
                            <v-radio color="#3E7662" style="padding-right: 50px" label="คงเดิม" value="2"></v-radio>
                            <v-radio color="#3E7662" label="ลดลง" value="3"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 4 -->
                <v-card class="mb-12">
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex>
                      <span>การปรับเอกสารชี้แจงข้อมูลแก่อาสาสมัคร</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pa-12>
                    <v-flex>
                      <!-- Causality of event -->
                      <v-layout mb-6>
                        <v-flex class="text-start">
                          <span class="font-weight-bold">Causality of event</span>
                        </v-flex>
                      </v-layout>
                      <!-- Form Radio -->
                      <v-layout mt-5 ml-6>
                        <v-flex class="text-start">
                          <v-radio-group v-model="form.eventCausality"
                            :readonly="$route.query.read == 1 ? true : false">
                            <v-radio @click="() => {
                              if ($route.query.read != 1)
                                form.hasClarificationDocument = '';
                            }
                              " class="mb-4" color="#3E7662"
                              label="1. ไม่ต้องเปลี่ยนแปลงเอกสารชี้แจงข้อมูลแก่อาสาสมัคร" value="1"></v-radio>
                            <v-radio class="mb-4" color="#3E7662" label="2. การปรับเอกสารชี้แจงข้อมูลแก่อาสาสมัคร"
                              value="2"></v-radio>
                            <v-radio-group class="pl-6" v-if="form.eventCausality == 2"
                              v-model="form.hasClarificationDocument" :readonly="$route.query.read == 1 ? true : false">
                              <!-- <v-radio
                                class="mb-4"
                                color="#3E7662"
                                label="ได้ปรับแล้ว"
                                value="1"
                              ></v-radio> -->
                              <v-radio class="mb-4" color="#3E7662"
                                label="ปรับเอกสารชี้แจงข้อมูลแก่อาสาสมัครสําหรับอาสาสมัครที่เข้ามาใหม่"
                                value="2"></v-radio>
                              <v-radio class="mb-4" color="#3E7662"
                                label="ปรับเอกสารชี้แจงข้อมูลแก่อาสาสมัครสําหรับอาสาสมัครเก่า และอาสาสมัครที่เข้า"
                                value="3"></v-radio>
                            </v-radio-group>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 5 -->
                <v-card class="mb-12">
                  <v-layout py-4 style="background-color: #3E7662;color: white;font-weight: bold">
                    <v-flex pl-6>
                      <span>สรุปผลการทบทวน</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pa-12>
                    <v-flex>
                      <v-radio-group v-model="form.checkmajor">
                        <!-- Minor Amendment -->
                        <v-layout mb-6>
                          <v-flex shrink class="text-start d-flex align-center">
                            <v-radio value="1" @click="clearCheckBox('minor')"></v-radio>
                          </v-flex>
                          <v-flex class="text-start">
                            <span class="font-weight-bold">Minor Amendment</span>
                          </v-flex>
                        </v-layout>
                        <!-- Form Radio -->
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-radio-group v-model="form.minorAmendment"
                              :readonly="$route.query.read == 1 ? true : false" :disabled="form.checkmajor != 1">
                              <!-- <v-radio-group
                                v-model="form.selectMinorAmendment"
                              > -->
                              <v-radio class="mb-4" color="#3E7662" label="1. รับรอง" value="1"></v-radio>
                              <v-radio class="mb-4" color="#3E7662"
                                label="2. รับรอง ภายหลังปรับปรุงแก้ไข หรือได้รับข้อมูลเพิ่มเติม" value="2"></v-radio>
                              <!-- </v-radio-group> -->
                            </v-radio-group>
                          </v-flex>
                        </v-layout>

                        <!-- Major Amendment -->
                        <v-layout mb-6 mt-6>
                          <v-flex shrink class="text-start d-flex align-center">
                            <v-radio value="2" @click="clearCheckBox('major')"></v-radio>
                          </v-flex>
                          <v-flex class="text-start">
                            <span class="font-weight-bold">Major Amendment</span>
                          </v-flex>
                        </v-layout>
                        <!-- Form Radio -->
                        <v-layout mt-5 ml-6>
                          <v-flex class="text-start">
                            <v-checkbox :readonly="$route.query.read == 1 ? true : false" color="#3E7662"
                              label="นำเข้าพิจารณาในที่ประชุมคณะอนุกรรมการฯ" v-model="form.majorAmendment"
                              :disabled="form.checkmajor != 2" />
                          </v-flex>
                        </v-layout>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Card 6 -->
                <v-card class="mb-12">
                  <v-layout pa-12>
                    <v-flex class="text-start">
                      <!-- ข้อคิดเห็นและแนะนำ -->
                      <v-layout mb-4>
                        <v-flex>
                          <span class="font-weight-bold">ข้อคิดเห็นและแนะนำ</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <TextareaForm :readonly="$route.query.read == 1 ? true : false" :model="form.adviceTextBox"
                            @update-data="updateData('adviceTextBox', $event)" />
                        </v-flex>
                      </v-layout>
                      <v-layout mb-4>
                        <v-flex>
                          <span class="font-weight-bold">สรุปประเด็น</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex>
                          <TextareaForm :readonly="$route.query.read == 1 ? true : false" :model="form.summarizeBox"
                            @update-data="updateData('summarizeBox', $event)" />
                        </v-flex>
                      </v-layout>

                      <!-- ผู้ประเมิน -->
                      <v-layout style="margin-top: 100px;">
                        <v-flex xs6>
                          <v-layout>
                            <v-flex xs3 mt-4 class="justify-start font-weight-bold d-flex align-center">
                              <span>อนุกรรมการฯ ผู้ทบทวน</span>
                            </v-flex>
                            <v-flex xs6 class="text-start text-field-center">
                              <v-text-field :readonly="$route.query.read == 1 ? true : false
                                " hide-details v-model="form.signature" color="#3E7662" append-icon="edit" />
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs3></v-flex>
                            <v-flex xs6 class=" text-field-center">
                              <v-layout>
                                <v-flex mr-2 mt-5 shrink class="d-flex align-center">
                                  <span>(</span>
                                </v-flex>
                                <v-flex>
                                  <v-text-field :readonly="$route.query.read == 1 ? true : false
                                    " hide-details v-model="form.signature" color="#3E7662" />
                                </v-flex>
                                <v-flex ml-2 mt-5 shrink class="d-flex align-center">
                                  <span>)</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-spacer></v-spacer>
                          </v-layout>
                        </v-flex>
                        <!--                                        <v-spacer></v-spacer>-->
                        <v-flex xs6 class="text-end">
                          <v-layout>
                            <v-spacer></v-spacer>
                            <v-flex xs2 mr-2 class="text-end font-weight-bold d-flex align-center">
                              <span>วันที่ทบทวน</span>
                            </v-flex>
                            <v-flex xs6 class="text-end text-field-center">
                              <DateInputForm v-if="$route.query.read == 0" hide-detail :model="dateChange"
                                @update-data="updateDate('date', $event)" />
                              <TextfieldForm v-else readonly :model="dateChange" hide-detail />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <!-- Date -->
                      <v-layout mt-8 style="margin-bottom: 100px;">
                        <v-flex xs3> </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout class="pl-12 pb-12">
                    <v-flex class="text-start font-weight-bold">
                      <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Button Save -->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: right;">
                    <v-layout>
                      <v-flex>
                        <v-btn style="color: #3E7662" class="mx-4" depressed color="#ffffff"
                          @click="$router.go(-1)">ย้อนกลับ</v-btn>
                        <v-btn depressed dark class="mx-4" color="#3E7662" @click="saveDraft">
                          <span>บันทึกข้อมูล</span>
                        </v-btn>
                        <v-btn v-if="$route.query.read == 0" depressed dark color="#3E7662" @click="save">
                          <span>บันทึกข้อมูลและส่งการประเมิน</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-pageAndLine="fullpageAndLine">
        </loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "FormRO02",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data() {
    return {
      isLoading: false,
      fullpageAndLine: true,
      form: {
        // selectMinorAmendment: "",
        researchID: "",
        researchCode: "",
        firstName: "",
        lastName: "",
        researchName: "",
        checkTheCriteria1: false,
        checkTheCriteria2: false,
        checkTheCriteria3: false,
        checkTheCriteria4: false,
        checkTheCriteria5: false,
        checkTheCriteria6: false,
        checkTheCriteria7: false,
        checkTheCriteria8: false,
        checkTheCriteria9: false,
        checkTheCriteria10: false,
        checkTheCriteria11: false,
        criteria11: "",
        hasFullBoardReview: false,
        hasExpeditedReview: false,
        fullBoardReview: "",
        exprditedReview: "",
        risk: "",
        expectBenefit: "",
        eventCausality: "",
        minorAmendment: "",
        majorAmendment: false,
        adviceTextBox: "",
        signature: "",
        date: "",
        hasClarificationDocument: "",
        summarizeBox: "",
        checkborad: "",
        checkmajor: "",
      },
      dateChange: "",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // if(this.checkmajor)
    // Check Permission Access
    //    if (this.user.currentRole !== 3) {
    //       this.$router.go(-1);
    //   }
    // Set data User
    // this.form.researchCode = this.$route.query.researchCode;
    // this.form.researchName = this.$route.query.researchName;
    // this.form.researcher = this.$route.query.researcher;
    // if(this.$route.query.researcher) {
    //     let text = this.$route.query.researcher.split(" ");
    //     this.form.firstName = text[0];
    //     this.form.lastName = text[1];
    // }
    this.form.researchCode = this.$route.query.researchCode;
    this.form.researchName = this.$route.query.researchName;
    this.form.firstName = this.$route.query.firstName;
    this.form.lastName = this.$route.query.lastName;
    this.form.signature = this.user.thName;
    this.getRO05();
    if (this.$route.query.read == 0) {
      this.updateDate("date", { date: new Date().toISOString().substr(0, 10) });
    }
  },
  methods: {
    async printPage() {
      this.printMode = true;
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function (element) {
        element.style.display = "none";
      });
      await document.querySelectorAll(".v-icon").forEach(function (element) {
        element.style.display = "none";
      });
      await document
        .getElementsByClassName("v-input--checkbox v-input--is-label-active")
        .forEach(function (element) {
          element.innerHTML = "✓" + element.innerHTML;
        });
      await document
        .getElementsByClassName("v-radio v-item--active")
        .forEach(function (element) {
          element.innerHTML = "✓ " + element.innerHTML;
        });
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function (dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false;
          await document.querySelectorAll("button").forEach(function (element) {
            element.style.display = "unset";
          });
          await document
            .getElementsByClassName(
              "v-input--checkbox v-input--is-label-active"
            )
            .forEach(function (element) {
              element.innerHTML = element.innerHTML.replace("✓", "");
            });
          await document
            .getElementsByClassName("v-radio v-item--active")
            .forEach(function (element) {
              element.innerHTML = element.innerHTML.replace("✓ ", "");
            });
          await document.querySelectorAll(".v-icon").forEach(function (element) {
            element.style.display = "unset";
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function (error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function () {
            await document
              .querySelectorAll("button")
              .forEach(function (element) {
                element.style.display = "unset";
              });
            await document
              .getElementsByClassName(
                "v-input--checkbox v-input--is-label-active"
              )
              .forEach(function (element) {
                element.innerHTML = element.innerHTML.replace("✓", "");
              });
            await document
              .getElementsByClassName("v-radio v-item--active")
              .forEach(function (element) {
                element.innerHTML = element.innerHTML.replace("✓ ", "");
              });
            await document
              .querySelectorAll(".v-icon")
              .forEach(function (element) {
                element.style.display = "unset";
              });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          });
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "date") {
        this.form.date = val;
        this.dateChange = this.changeDate(val);
      }
      if (name === "estimateDateGet") {
        this.form.date = val;
        this.dateChange = this.changeDate(val);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    checkbox(name) {
      if (name === "checkTheCriteria11") {
        if (!this.form.checkTheCriteria11) {
          this.form.criteria11 = "";
        }
      }
      if (name === "hasFullBoardReview") {
        this.form.criteria11 = "";
        this.form.checkTheCriteria1 = false;
        this.form.checkTheCriteria2 = false;
        this.form.checkTheCriteria3 = false;
        this.form.checkTheCriteria4 = false;
        this.form.checkTheCriteria5 = false;
        this.form.checkTheCriteria6 = false;
        this.form.checkTheCriteria7 = false;
        this.form.checkTheCriteria8 = false;
        this.form.checkTheCriteria9 = false;
        this.form.checkTheCriteria10 = false;
        this.form.checkTheCriteria11 = false;
      }
      if (name === "checkTheCriteria11") {
        this.form.fullBoardReview = "";
        this.form.hasFullBoardReview = false;
      }
    },
    clearCheckBox(name) {
      console.log(name);
      if (name === "minor") {
        this.form.majorAmendment = "";
      }
      if (name === "major") {
        this.form.minorAmendment = "";
        // this.form.selectMinorAmendment = "";
      }
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          if (this.validateData(this.form)) {
            this.isLoading = true;
            this.form["researchID"] = this.$route.query.id;
            this.form["researchAmendmentID"] = this.$route.query.rfType;
            this.form["rfID"] = this.$route.query.rfID;
            this.$store
              .dispatch("FormRO/saveRO05", this.form)
              .then((res) => {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "บันทึกสำเร็จ",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  this.$router.go(-1);
                });
                this.isLoading = false;
              })
              .catch((e) => {
                this.isLoading = false;
                if (e.response.data.errors) {
                  for (var k in e.response.data.errors) {
                    Swal.fire({
                      title: "เกิดข้อผิดพลาด",
                      text: e.response.data.errors[k][0],
                      icon: "warning",
                      confirmButtonColor: "#3E7662",
                    }).then(() => {
                      this.$vuetify.goTo(`#${k}`);
                    });
                  }
                }
                // Swal.fire({
                //     title: 'Save failed!',
                //     text: 'บันทึกไม่สำเร็จ',
                //     icon: 'warning',
                //     confirmButtonColor: '#3E7662',
                // })
                // this.isLoading = false;
              });
          }
        }
        this.isLoading = false;
      });
    },
    saveDraft() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          if (this.validateData(this.form)) {
            this.isLoading = true;
            this.form["researchID"] = this.$route.query.id;
            this.form["researchAmendmentID"] = this.$route.query.rfType;
            this.form["rfID"] = this.$route.query.rfID;
            this.$store
              .dispatch("FormRO/saveDraftRO05", this.form)
              .then((res) => {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "บันทึกสำเร็จ",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  this.$router.go(-1);
                });
                this.isLoading = false;
              })
              .catch((e) => {
                this.isLoading = false;
                if (e.response.data.errors) {
                  for (var k in e.response.data.errors) {
                    Swal.fire({
                      title: "เกิดข้อผิดพลาด",
                      text: e.response.data.errors[k][0],
                      icon: "warning",
                      confirmButtonColor: "#3E7662",
                    }).then(() => {
                      this.$vuetify.goTo(`#${k}`);
                    });
                  }
                }
                // Swal.fire({
                //     title: 'Save failed!',
                //     text: 'บันทึกไม่สำเร็จ',
                //     icon: 'warning',
                //     confirmButtonColor: '#3E7662',
                // })
                // this.isLoading = false;
              });
          }
        }
        this.isLoading = false;
      });
    },
    async getRO05() {
      this.isLoading = true;
      await this.$store
        .dispatch("FormRO/getRO05", {
          researchID: this.$route.query.id,
          rfID: this.$route.query.rfID,
        })
        .then((res) => {
          this.updateDate("date", res.date);
          // for (let i = 1; i <= 11; i++) {
          //   this.form[`checkTheCriteria${i}`] = !!res[`checkTheCriteria${i}`];
          // }
          // this.form.selectMinorAmendment = res.selectMinorAmendment == 1 ? "1" : "2";
          this.form.majorAmendment = res.majorAmendment == 1;
          this.form.researchID = res.researchID;
          this.form.researchCode = res.researchCode;
          this.form.firstName = res.firstName;
          this.form.lastName = res.lastName;
          this.form.researchName = res.researchName;
          this.form.criteria11 = res.criteria11 ? res.criteria11 : "";
          this.form.hasFullBoardReview =
            res.hasFullBoardReview == 1 ? true : false;
          this.form.fullBoardReview = res.fullBoardReview;
          this.form.summarizeBox = res.summarizeBox;
          this.form.checkmajor = res?.checkmajor?.toString();
          this.form.checkborad = res?.checkborad?.toString();
          this.form.risk = res?.risk?.toString();
          this.form.expectBenefit = res?.expectBenefit?.toString();
          this.form.eventCausality = res?.eventCausality.toString();
          this.form.minorAmendment = res?.minorAmendment.toString();
          this.form.adviceTextBox = res.adviceTextBox;
          this.form.signature = res.signature;
          this.form.hasClarificationDocument = res?.hasClarificationDocument?.toString();
          this.updateDate("estimateDateGet", res.date);
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    validateData(data) {
      if (!data.summarizeBox) {
        Swal.fire({
          title: "ใบตอบรับเอกสาร Receipt",
          text: "กรุณาระบุ กรุณากรอก สรุปประเด็น",
          icon: "warning",
        });
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
.table-ro4-1 {

  /*** Table Styles **/
  .table-style-ro04-1 {
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }

    .table-fill-ro04-1 {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      /*border-bottom: 5px solid #544A44;*/
    }

    th {
      color: #ffffff;
      background: #3e7662;
      /*border-top:5px solid #544A44;*/
      border-right: 0.75px solid gray;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }

    tr {
      border-top: 1px solid #544a44;
      border-bottom-: 1px solid #544a44;
    }

    th:first-child {
      border-top-left-radius: 3px;
    }

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr:first-child {
      /*border-top: none;*/
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid gray;
      border-top: 0.5px solid gray;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {

  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}

.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}
</style>
